export const isMobile = () => {
  const userAgent = navigator.userAgent
  return /Mobi|Android|iPhone/i.test(userAgent)
}

const getOSInfo = () => {
  const userAgent = navigator.userAgent

  if (userAgent.includes('Windows')) {
    return 'Windows'
  } else if (userAgent.includes('Mac')) {
    return 'MacOS'
  } else if (userAgent.includes('Linux')) {
    return 'Linux'
  } else if (userAgent.includes('Android')) {
    return 'Android'
  } else if (userAgent.includes('iOS')) {
    return 'iOS'
  }

  return 'Unknown'
}

const getBrowserInfo = () => {
  const userAgent = navigator.userAgent

  if (userAgent.includes('Firefox')) {
    return 'Firefox'
  } else if (userAgent.includes('Chrome') && !userAgent.includes('Edg')) {
    return 'Chrome'
  } else if (userAgent.includes('Safari') && !userAgent.includes('Chrome')) {
    return 'Safari'
  } else if (userAgent.includes('Edg')) {
    return 'Edge'
  } else if (userAgent.includes('Opera') || userAgent.includes('OPR')) {
    return 'Opera'
  } else if (userAgent.includes('MSIE') || userAgent.includes('Trident')) {
    return 'Internet Explorer'
  }

  return 'Unknown'
}

export const isPictureInPictureSupported = () => {
  return (
    'documentPictureInPicture' in window && document.pictureInPictureEnabled
  )
}

export const isGetDisplayMediaSupported = () => {
  return (
    navigator.mediaDevices &&
    typeof navigator.mediaDevices.getDisplayMedia === 'function'
  )
}

export default {
  browser: getBrowserInfo(),
  os: getOSInfo(),
  isMobile: isMobile(),
}
